module.exports = __webpack_public_path__ + "img/buddy_nose-02.c8743f6b.svg";